import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingTop: 40,
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  topImageWrapper: {
    top: '-100px',
    width: '100%',
    maxHeight: 400,
    transform: 'rotate(-10deg)',
    marginBottom: 0,
    paddingLeft: 53,
    paddingBottom: 53,
  },
  topImage: {
    top: '-50px',
    width: '100%',
    height: 'auto',
    maxHeight: 300,
    borderRadius: '1rem',
  },
  centerImageWrapper: {
    top: '-130px',
    width: '70%',
    justifyContent: 'center',
    alignItems: 'center',

    maxWidth: '370px',
    maxHeight: '150px',
  },
  centerImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
  textContainer: {
    marginTop: 30,
    alignItems: 'center',
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    textAlign: 'center',
    fontWeight: 700,
    marginBottom: 10,
  },
  subtitle: {
    color: '#27343d',
    fontSize: 11,
    textAlign: 'center',
  },

  citationWrapper: {
    textAlign: 'center',
    top: '-80px',
    height: 'auto',
    width: '100%',
    marginTop: 10,
    paddingTop: 30,
    paddingBottom: 30,
  },
  citationInnerWrapper: {
    maxWidth: 600,
    alignItems: 'center',
  },
  citation: {
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    color: '#fff',
    textAlign: 'center',
  },
  line: {
    width: 130,
    borderTopWidth: 2,
    borderColor: '#fff',
    marginTop: 10,
    marginBottom: 10,
  },
  personDetails: {
    color: '#fff',
    fontSize: 9,
    textAlign: 'center',
  },

  threeColumnWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%',
    marginTop: 0,
    marginBottom: 20,
  },
  column: {
    flex: 1,
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 3,
  },
  leftImage: {
    width: 80,
    height: 'auto',
    marginBottom: 10,
  },
  leftText: {
    fontSize: 9,
    textAlign: 'center',
  },
  middleText: {
    fontSize: 9,
    marginBottom: 10,
    textAlign: 'center',
  },
  linkButton: {
    backgroundColor: 'black',
    borderRadius: 4,
    color: '#fff',
    fontSize: 9,
    textAlign: 'center',
    textDecoration: 'none',

    marginTop: 5,
    paddingVertical: 6,
    paddingHorizontal: 12,

    width: '100%',
  },
  rightText: {
    fontSize: 9,
    marginBottom: 5,
    textAlign: 'center',
  },
  rightImage: {
    width: 90,
    height: 'auto',
    marginBottom: 5,
  },
});
